import {NewsItem, User} from "../../types/Types";
import React from "react";
import {addAnchorTags, getDate, getTime} from "../../util/Util";
import {faTrash} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import UserTag from "../../users/tag/UserTag";
import LikeButton from "../../tag/likes/LikeButton";

interface Props {
    comment: NewsItem;
    commentUser: User | undefined;
    user: User;
    deleteComment: (arg0: string) => void;
    likesMap: Map<string, boolean>;
    onLikeCountChange?: (commentId: string, adjustment: number) => void;
}

function CommentRow(props: Props) {

    return (
        <>
            {<div className={"news-item"} style={{paddingBottom: "0.5em"}}>
                <div style={{marginBottom: "0.5em"}}>
                    <div className={"d-inline-block"}><UserTag
                        user={props.commentUser}
                        visit={undefined}
                        session={undefined}
                        padRight={false}
                        hideLocationDot={true}
                        linksToTab={"comments"}
                    /></div>
                    <span className={"ml-1 mr-1"}>
                        "<span dangerouslySetInnerHTML={{ __html: addAnchorTags(props.comment.payload)}} />"
                    </span>
                </div>
                <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                    <div style={{float: "left"}}>
                        <LikeButton
                            entityId={props.comment.id}
                            likeType="COMMENT"
                            initialLikeCount={props.comment.likeCount || 0}
                            isLiked={props.likesMap.get(props.comment.id) || false}
                            currentUser={props.user}
                            locationId={props.comment.locationId}
                            locationName={props.comment.locationName}
                            onLikeCountChange={props.onLikeCountChange}
                        />
                    </div>
                    <div style={{float: "right"}}>
                        <small>
                            {(props.user.id === props.comment.userId || props.user.admin) &&
                            <FontAwesomeIcon style={{cursor: "pointer"}}
                                             onClick={() => {props.deleteComment(props.comment.id)}}
                                             icon={faTrash} />}
                        </small>
                        <small className={"ml-2 d-inline-block"}>
                            <div className={"d-inline-block"}>{getDate(props.comment.lastModified)} at {getTime(props.comment.lastModified)}</div>
                        </small>
                    </div>
                </div>
            </div>}
        </>
    )
}

export default CommentRow;